import { type RenderMark } from '@contentful/rich-text-react-renderer'
import { FontSizeContext } from '@contexts/fontsize'
import React, { useContext } from 'react'

export const italicImageText: RenderMark[string] = (text) => {
  const fontSize = useContext(FontSizeContext)

  return (
    <span style={{ fontSize: fontSize }}>
      <span className="align-top text-[3.125em]/[2.625em] text-theme-default-main laptop:text-[4.375em]/[2em]">
        {text}
      </span>
    </span>
  )
}
